
  <section class="widget" #self>
    <a href="https://rate-match.com" target="_blank">
      <img
        src="https://rate-match.com/img/svg/logo.svg" 
        width="48px" 
        style="margin-bottom: -10px; margin-left: 25px;"
      />
    </a>
    @if (ready === true) {
      <div class="content d-flex gap-2">
        <button class="open-dates-mobile" (click)="openMobileSeach()">
          {{'reserver'|translate}}
        </button>
        <div [@routeTransition]="animationTrigger$|async">
          <router-outlet></router-outlet>
        </div>
        <div>
          <a (click)="openSearchPanel(); maximize()" [routerLink]="['prices']" routerLinkActive="active" queryParamsHandling="merge"  class="open-prices">
            <tui-icon icon="@tui.calendar-check" [style.height.px]="15"></tui-icon>
            <span>{{'prix'|translate}}</span>
          </a>
          @if ((selectWHasComment$|async)==true) {
            <a (click)="maximize()" [routerLink]="['comments']" routerLinkActive="active" queryParamsHandling="merge" class="open-avis">
              <tui-icon icon="@tui.message-circle" [style.height.px]="15"></tui-icon>
              <span>{{'avis'|translate}}</span>
            </a>
          }
        </div>
      </div>
    }
    @else if(ready === false){
      <p>No widget data</p>
    }
  </section>